import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col} from 'reactstrap';
import { subscribe } from 'react-contextual';
import COLORS from '../../../../../common/colors';
import {PriceTag} from '../../utils';
import LocationIcon from '../../icons/locationIcon';
import { Tag } from '../../../elements';
import Image from '../../../elements/image';
import selectSuggestedPrice from '../../../../../util/selectSuggestedPrice';
import MatchedAmount from '../../matchedAmount';

const fullySupportedBoxStyle = {
	margin: 0, padding: '5px', display: 'inline-block', border: '1px solid #ff5050', borderRadius: '5px',
};

const ProgramCard = (props) => {
	const {
		cause,
		location,
		title,
		ngo,
		price,
		image,
		alt,
		id,
		programLink,
		reliabilityRating,
		headline,
		displayName,
		isInventoryAvailable,
		tags,
		matching,
		suggestedPrices,
		type,	
	} = props.program;

	const {
		panelTitle, position, newTab, lazyLoadImage, tenantConfig,CFPrograms
	} = props;

	let defaultMatchingPercentage = props.program.defaultMatchingPercentage;
	if (!defaultMatchingPercentage && defaultMatchingPercentage !== 0) {
		defaultMatchingPercentage = props.defaultMatchingPercentage;
	}

	if (Object.keys(props.program).length === 0 && props.program.constructor === Object) {
		return null;
	}

	const programPrice = selectSuggestedPrice(type, suggestedPrices, props.tenantConfig, price);


	const imageType = props.imageType || 'thumbnail';
	return (
		<Col className={props.className} lg={props.size.lg} md={props.size.md} sm={props.size.sm} xs={props.size.xs}>
			<Card>
				<a
					rel="noopener noreferrer"
					className="no-hover-a"
					style={{ cursor: 'pointer' }}
					href={`${!CFPrograms ? '/program/' : 'https://fundraisers.giveindia.org/projects/'}${programLink}`}
					target={newTab ? '_blank' : '_self'}
					onClick={() => {
						const eventInfo = {
							panelTitle,
							category: cause,
							programType: type,
							position: position + 1,
							productName: title,
							productTypeId: 1,
							productId: id,
							ngo,
							programPrice,
							url: window.location.toString()
						};
						if (window.eventDispatcher) {
							window.eventDispatcher.dispatchEventSync('programClick', eventInfo, {amplitude: true});
						}

						return true;
					}}
				>

					<div style={{ position: 'relative' }}>
							<Image width="100%" style={{ opacity: 1}} src={image} alt={alt} type={imageType} lazyLoad={lazyLoadImage} />
						<div className="d-flex f-d-row" style={{position: 'absolute'}}>
						{/* {typeof matching !== 'undefined' && matching &&
						<MatchingIcon  height={35} matchingPercentage = {matching.matchingPercentage}/>} */}
						<TagRow tags={tags} matching={matching}/>
					</div>

					</div>
					<div className="card-body">
						<div className="card-tags row">
							<div className="col-6 col-lg-6 col-md-12 col-sm-6 p-0">
								<span className="small-text float-left" style={{ textTransform: 'capitalize', color: tenantConfig.theme.primaryColor }}>
									{cause}
								</span>
							</div>
							{location ? <div className="col-6 col-lg-6 col-md-12 col-sm-6 p-0">
								<span className="small-text mid-grey float-right" style={{ textTransform: 'capitalize' }}>
										<LocationIcon
										color={tenantConfig.theme.primaryColor}
										size="0.875rem"
										style={{
											display: 'inline-block', lineHeight: '0', marginRight: '3px', width: '0.875rem',
										}}
									/>
										{location}
								</span>
							</div>: null}
						</div>
						<h5 className="card-title text-clamp-3" style={{ lineHeight: '1.375rem' }}>
							{/* <Link prefetch href={programLink}>} */}
							<span className="darker-grey">
								{displayName || headline || title}
							</span>
							<span className="sh w-100">
									&nbsp;by&nbsp;{ngo}
							</span>
						</h5>
						{!CFPrograms ? (
							!isInventoryAvailable ?
							<div style={{ position: 'relative' }}>
								<div className="card-price">
									<h6 className="jsx-3048130722 price" style={fullySupportedBoxStyle}> Fully Supported </h6>
								</div>
							</div> :
							<div className="card-price">
								<h6 className="price">
									<PriceTag price={programPrice} theme={tenantConfig.theme} session={props.session} /> <span className="sh"> per month </span>
								</h6>
							</div>
						) : null}
						
					</div>
				</a>

				{/* Matching Percentage */}

				{defaultMatchingPercentage !== matching ? (<MatchedAmount matchValue={matching} />): null}




			</Card>
			<style jsx global>{`
				.card-price {
					margin-bottom: 10px;
				}
				.card-price h6 {
					margin-bottom: 0;
					font-weight: 600
				}
				.tag-row {
					margin-bottom: 10px;
				}
				.giveassured-position {
					position: absolute;
					bottom: 3px;
					right: 3px;
					background: white;
					padding: 1px 5px;
					border-radius: 5px;
					box-shadow: 0 2px 2px rgba(50,50,93,0), 0 1px 2px rgba(0,0,0,0.08);
				}
			`}
			</style>
		</Col>
	);
};

const TagRow = ({ tags, matching }) => (
	typeof tags !== 'undefined'  ?
		<div className="justify-content-end align-self-start tag-row-position d-flex">
			{tags.map((tag, index) => <Tag {...tag} key={index} design="capsule"
			matchingPercentage={typeof matching !== undefined && matching ? matching.matchingPercentage : null}/>)}
		</div>
		:
		null
);

ProgramCard.propTypes = {
	program: PropTypes.shape({
		cause: PropTypes.string,
		location: PropTypes.string,
		title: PropTypes.string,
		ngo: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
		image: PropTypes.string.isRequired,
		programLink: PropTypes.string.isRequired,
	}).isRequired,
	panelTitle: PropTypes.string,
	size: PropTypes.shape({}),
};

ProgramCard.defaultProps = {
	size: { lg: '4', sm: '6', xs: '12', md: '6' },
	className: 'd-flex program-card-11',
};

export default subscribe()(ProgramCard);
